// import { AsbestosSusceptibilityLayer } from "../../layers/AsbestosSusceptibilityLayer/AsbestosSusceptibilityLayer";
// import { AsbestosInventoryLayer } from "../../layers/Asbestos/AsbestosInventoryLayer";
import DefaultLayerGroup from "../DefaultLayerGroup";
import { toast } from "react-toastify";
import {
  create_preliminar_element,
  delete_preliminar_element,
} from "../../../api/layers/ApiLayerAsbestos";
import {
  findLayerById,
  findLayerByUuid,
} from "../../../services/MapCore/LayerGroupService";
import i18n from "../../../utils/i18n";
// import { WmsLayer } from "../../layers/WmsLayer";
import { Button, IconButton, Tooltip } from "@mui/material";
import UndoIcon from "@mui/icons-material/Undo";
import { useTranslation } from "react-i18next";
import { Confirm } from "notiflix";
import { translations } from "../../../utils/i18n/translations";
import { WmsLayer } from "../../layers/WmsLayer";
import { GridLayer } from "../../layers/Grid/GridLayer";
import { AsbestosSusceptibilityLayer } from "../../layers/Asbestos/AsbestosSusceptibilityLayer";
import { AsbestosInventoryLayer } from "../../layers/Asbestos/AsbestosInventoryLayer";
import {
  addFeatureLayerToMap,
  removeHighlightLayerFromMap,
} from "../../../services/MapCore/MapService";
import LayerSettings from "../../layers/LayerSettings";
import { HighlightFeatureLayer } from "../../layers/HighlightFeatureLayer";
// import { GridLayer } from "../../layers/GridLayer";

class AsbestosLayerGroup extends DefaultLayerGroup {
  constructor(map = null, layer_group_data) {
    super(map, layer_group_data);

    this.has_filter = true;

    this.id = this.id.replace("default-", "");
    this.id = this.id.replace(
      layer_group_data.uuid,
      `asbestos-${layer_group_data.uuid}`
    );

    this.layers = this.createLayers();
  }

  createLayers = () => {
    const TYPE_MAP = {
      DEFAULT: WmsLayer,
      GRID: GridLayer,
      AMIANTO_SUSCEPTIBILIDAD: AsbestosSusceptibilityLayer,
      AMIANTO_CENSO: AsbestosInventoryLayer,
    };

    const layers_to_add = [];

    for (const layer_data of this.layer_list_data) {
      const { layer_type } = layer_data;

      let new_layer_type = layer_type;

      if (!Object.keys(TYPE_MAP).includes(layer_type))
        new_layer_type = "DEFAULT";

      const new_layer = new TYPE_MAP[new_layer_type](layer_data, this.id);
      layers_to_add.push(new_layer);
    }
    return layers_to_add;
  };

  async onLeftClick({ event, map, modeOptions, setEditedGeometry }) {
    // console.log("AsbestosLayerGroup onLeftClick", this.layers);
    if (
      !this.layers.some((layer) =>
        modeOptions.ASBESTOS_CLICK.includes(layer.id)
      )
    )
      return super.onLeftClick({ event, map, modeOptions });

    const features = [];
    let feature_susceptibility, feature_inventory, feature_highlighted;
    let preliminar_layer_uuid = "";
    let inventory_layer = false;

    for (const layer of this.layers) {
      let layerFeature = await layer.getFeatureInfoOnClick(event, map);

      if (layer.layer_data.layer_type == "AMIANTO_CENSO") {
        feature_inventory = layerFeature;
        preliminar_layer_uuid = layer.layer_data.uuid;
        inventory_layer = layer;
      } else if (layer.layer_data.layer_type == "AMIANTO_SUSCEPTIBILIDAD") {
        feature_susceptibility = layerFeature;
      }

      if (layerFeature?.length > 0 && layer.visible) {
        layerFeature[0] = {
          ...layerFeature[0],
          layer_name: layer.name,
          layer_type: layer.layer_data.layer_type,
        };
        features.push(layerFeature);
      }
    }

    // Buscar la capa en this.layers que sea de tipo HighlightFeatureLayer
    const highlightLayerIndex = this.layers.findIndex(
      (layer) => layer instanceof HighlightFeatureLayer
    );

    if (highlightLayerIndex !== -1) {
      // Eliminar la capa de this.layers
      this.layers.splice(highlightLayerIndex, 1);

      // Eliminar la capa del mapa
      removeHighlightLayerFromMap(map);
    } else {
      console.log("No se encontró la capa de resaltado.");
    }

    if (feature_inventory && feature_inventory.length > 0) {
      const highlightFeatureLayer = this.layers.find(
        (layer) => layer instanceof HighlightFeatureLayer
      );

      if (highlightFeatureLayer) {
        if (
          highlightFeatureLayer.uuid === feature_inventory[0].properties.uuid
        ) {
          return features;
        }
      }
      const featureVectorLayer = addFeatureLayerToMap(
        map,
        feature_inventory[0].geometry,
        setEditedGeometry
      );

      const featureLayer = new HighlightFeatureLayer(
        {
          layer: featureVectorLayer,
          uuid: feature_inventory[0].properties.uuid,
        },
        this.id
      );

      this.layers.push(featureLayer);

      // DEVUELVE EL FEATURE PARA EL FORMULARIO
      return features;
    } else {
      if (feature_susceptibility && feature_susceptibility.length > 0) {
        // ----------------------------------------------------------------------------------------
        //                             HAY SUSCEPTIBILIDAD SOLO, SE COPIA EL ELEMENTO
        // ----------------------------------------------------------------------------------------

        const toast_id_copying_element = toast.info(
          `${translations[i18n.language].copying_element}...`,
          {
            // position: "top-right",
            loading: true,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );

        try {
          let data = feature_susceptibility[0]["properties"];
          let geom = feature_susceptibility[0]["geometry"];
          geom = {
            type: "Feature",
            geometry: geom,
          };

          data["geometry"] = geom;
          data["status"] = "PRELIMINAR";
          data["inspection_type"] = "PRELIMINAR";

          const newElement = await create_preliminar_element(
            preliminar_layer_uuid,
            data
          );

          const layer_g = findLayerById(map, inventory_layer.id);

          layer_g.getSource().updateParams({ t: Date.now() });

          toast.update(toast_id_copying_element, {
            render: translations[i18n.language].element_copied_successfully,
            type: "success",
            isLoading: false,
            //delay: 1,
            autoClose: 10000,
            closeButton: (
              <UndoButton
                item_uuid={newElement.uuid}
                layerUuid={preliminar_layer_uuid}
                map={map}
              />
            ),
          });
        } catch {
          console.error("Error en la petición");
          toast.update(toast_id_copying_element, {
            render: translations[i18n.language].element_copying_error,
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
        }
      } else {
        // ----------------------------------------------------------------------------------------
        //                             NO HAY ELEMENTOS; SE CREA UNO NUEVO
        // ----------------------------------------------------------------------------------------

        inventory_layer.createInventoryPoint({
          coordinates: event["coordinate_"],
          map,
        });
      }
    }
  }
}

export default AsbestosLayerGroup;

export const UndoButton = ({ item_uuid, layerUuid, map, onClick }) => {
  const { t } = useTranslation("main");

  const handleClose = async (ev) => {
    ev.stopPropagation();
    ev.preventDefault();

    Confirm.show(
      t("delete_element_title"),
      t("delete_element_body"),
      t("yes"),
      t("no"),

      async () => {
        const toast_id_deleting_element = toast.loading(
          `${t("deleting_element")}...`,
          {
            position: "top-right",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        await delete_preliminar_element(item_uuid, layerUuid);

        const layer = findLayerByUuid(map, layerUuid);

        layer?.getSource()?.updateParams({ t: Date.now() });
        toast.update(toast_id_deleting_element, {
          render: t("element_deleted_successfully"),
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });

        // toast.success(t("element_deleted_successfully"), {
        //   hideProgressBar: false,
        //   loading: true,
        //   autoClose: 5000,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   theme: "light",
        // });
      },
      () => {},
      {}
    );
  };

  return (
    <Tooltip title={t("undo")}>
      <IconButton
        sx={{ color: "#00be2c" }}
        className="toastButton"
        onClick={onClick ?? handleClose}
      >
        <UndoIcon />
      </IconButton>
    </Tooltip>
  );
};
